<template>
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.67883 10.7374L8.06008 9.1187L7.17883 9.99995L9.67883 12.4999L14.0538 8.12495L13.1726 7.2437L9.67883 10.7374Z"
      fill="var(--color, #04785E)"
    />
    <path
      d="M19.0538 9.375H17.7721C17.6224 7.61022 16.8533 5.95526 15.6009 4.70289C14.3486 3.45052 12.6936 2.68146 10.9288 2.53175V1.25H9.67883V2.53175C7.91405 2.68146 6.25909 3.45052 5.00672 4.70289C3.75435 5.95526 2.98529 7.61022 2.83558 9.375H1.55383V10.625H2.83558C2.98529 12.3898 3.75435 14.0447 5.00672 15.2971C6.25909 16.5495 7.91405 17.3185 9.67883 17.4682V18.75H10.9288V17.4682C12.6936 17.3185 14.3486 16.5495 15.6009 15.2971C16.8533 14.0447 17.6224 12.3898 17.7721 10.625H19.0538V9.375ZM10.9288 16.2182V14.375H9.67883V16.2182C8.24522 16.0721 6.90591 15.4359 5.88693 14.4169C4.86796 13.3979 4.23172 12.0586 4.08558 10.625H5.92883V9.375H4.08558C4.23172 7.94138 4.86796 6.60207 5.88693 5.5831C6.90591 4.56412 8.24522 3.92788 9.67883 3.78175V5.625H10.9288V3.78175C12.3625 3.92788 13.7018 4.56412 14.7207 5.5831C15.7397 6.60207 16.3759 7.94138 16.5221 9.375H14.6788V10.625H16.522C16.3758 12.0586 15.7396 13.3979 14.7207 14.4169C13.7017 15.4359 12.3624 16.0721 10.9288 16.2182Z"
      fill="var(--color, #04785E)"
    />
  </svg>
</template>
